"use client"

import { useEffect } from "react"

import { initAttribution } from "@/lib/attribution/client"

export function AttributionBootstrap() {
  useEffect(() => {
    initAttribution().catch((error) => {
      // Evita quebrar a página em caso de falha de attribution
      console.warn("[AttributionBootstrap] Erro ao inicializar attribution:", error)
    })
  }, [])

  return null
}

